// Shared row + schema printers for `wayai analytics sql` and `wayai evals sql`.

/**
 * The refusal for a query given beside `--schema`, which lists the columns and runs nothing: the
 * `--schema` branch returned before the query was read, so the query was skipped.
 */
export function queryWithSchemaRefusal(invocation: string): string {
  return `\`${invocation}\` was given both a query and \`--schema\`, which lists the columns instead of running one. It is refused rather than run on one of them alone: give the query or \`--schema\`, not both.`;
}

export function printQueryRows(rows: Array<Record<string, unknown>>): void {
  if (rows.length === 0) {
    console.log('(no rows)');
    return;
  }
  const columns = Object.keys(rows[0]);
  const widths = columns.map((c) => Math.max(c.length, ...rows.map((r) => formatCell(r[c]).length)));

  const header = columns.map((c, i) => c.padEnd(widths[i])).join('  ');
  console.log(header);
  console.log(columns.map((_, i) => '-'.repeat(widths[i])).join('  '));
  for (const row of rows) {
    console.log(columns.map((c, i) => formatCell(row[c]).padEnd(widths[i])).join('  '));
  }
}

interface SqlSchemaPath {
  path: string;
  type: string;
  origin: string;
  category?: string;
  description?: string;
}

export function printSqlSchema(
  data: {
    table: string;
    top_level: Array<{ column: string; type: string }>;
    paths: SqlSchemaPath[];
  },
  pathsHeader: string,
): void {
  console.log(`Table: ${data.table}\n`);
  console.log('Top-level columns:');
  for (const c of data.top_level) {
    console.log(`  ${c.column.padEnd(24)} ${c.type}`);
  }
  console.log(`\n${pathsHeader}`);
  const byCat = new Map<string, SqlSchemaPath[]>();
  for (const p of data.paths) {
    const key = p.category || p.origin;
    const arr = byCat.get(key) || [];
    arr.push(p);
    byCat.set(key, arr);
  }
  const cats = [...byCat.keys()].sort();
  for (const cat of cats) {
    console.log(`\n  [${cat}]`);
    for (const p of byCat.get(cat)!) {
      const desc = p.description ? ` — ${p.description}` : '';
      console.log(`    ${p.path.padEnd(48)} ${p.type}${desc}`);
    }
  }
}

function formatCell(value: unknown): string {
  if (value === null || value === undefined) return '';
  if (typeof value === 'number') return Number.isInteger(value) ? String(value) : value.toFixed(4);
  if (typeof value === 'object') return JSON.stringify(value);
  return String(value);
}
